<template>
  <div class="bd">
    <!-- 汽车废 -->
    <div class="mainitem">
      <div class="left" :style="'height:' + screenHeight">
        <div class="left-content" style="height: 40%">
          <div class="type-title">
            <div>产能总计</div>
          </div>
          <div class="company-content">
            <div
              class="item-list"
              v-for="(item, index) in dataList"
              :key="index"
            >
              <span>{{ item.title }}</span>
              <span>{{ item.content }}</span>
            </div>
          </div>
        </div>
        <div class="left-content slip_out_animation">
          <div class="type-title">
            <div>产能统计</div>
          </div>
          <div class="left-echarts-1" id="left-echarts-1"></div>
        </div>
      </div>

      <div class="right" :style="'height:' + screenHeight">
        <div class="right-content slip_in_animation" style="height: 40%">
          <div class="type-title">
            <div>今日产出物总计</div>
          </div>
          <div class="company-content">
            <div
              class="item-list"
              v-for="(item, index) in dataListRight"
              :key="index"
            >
              <span>{{ item.title }}</span>
              <span>{{ item.content }}</span>
            </div>
          </div>
        </div>
        <div class="right-content slip_in_animation">
          <div class="type-title">
            <div>产出物销售</div>
          </div>
          <div style="margin-top: 30px; padding-left: 20px">
            今日累计销售：<span style="font-size: 20px; color: red"
              >￥2343元</span
            >
          </div>
          <div class="right-echarts-1" id="right-echarts-1"></div>
        </div>
      </div>
    </div>
  </div>
</template>
  
  <script>
import * as echarts from "echarts";

export default {
  name: "indexModelTwo",
  props: ["screenHeight"],
  data() {
    return {
      selectIndex: 1,
      nowTime: "",
      dataList: [
        {
          title: "产能总计",
          content: "120台（93吨）/日",
        },
        {
          title: "新能源车",
          content: "23台（15吨）/日",
        },
        {
          title: "轿车",
          content: "53台（16吨）/日",
        },
        {
          title: "面包车",
          content: "24台（23吨）/日",
        },
        {
          title: "其他",
          content: "20台（76吨）/日",
        },
      ],
      dataListRight: [
        {
          title: "产能总计",
          content: "120（Kg)",
        },
        {
          title: "三元催化剂",
          content: "23（Kg)",
        },
        {
          title: "电脑板",
          content: "53（Kg)",
        },
        {
          title: "废铅酸蓄电池",
          content: "24（Kg)",
        },
        {
          title: "其他",
          content: "20（Kg)",
        },
      ],
    };
  },
  mounted() {
    setTimeout(() => {
      this.$nextTick(() => {
        this.createdCarEchartsLeftTop();
        this.createdCarEchartsRightBottom();
      });
    }, 300);
  },
  methods: {
    // 饼图
    createdCarEchartsLeftTop() {
      var leftEchartsTOP = document.getElementById("left-echarts-1");
      var myChart = echarts.init(leftEchartsTOP);
      var option;

      option = {
        title: {
          subtext: "单位：吨",
          left: "right",
          subtextStyle: {
            color: "#FFF",
            fontSize: "20",
          },
        },
        grid: {
          left: "50%",
          right: "150%",
          bottom: "300px",
        },
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            return (
              params.name +
              ":  " +
              params.data.value +
              "（" +
              params.percent +
              "%）"
            );
          },
        },
        color: [
          "#5470c6",
          "#91cc75",
          "#fac858",
          "#ee6666",
          "#73c0de",
          "#3ba272",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
        ],
        legend: {
          bottom: "bottom",
          textStyle: {
            fontSize: 20,
            color: "#FFFFFF",
          },
        },
        series: [
          {
            name: "数量",
            type: "pie",
            radius: "40%",
            data: [
              { value: 53, name: "轿车" },
              { value: 24, name: "面包车" },
              { value: 23, name: "新能源" },
              { value: 20, name: "其他" },
            ],
            label: {
              fontSize: 12,
              color: "#FFF",
              formatter(param) {
                return param.data.value;
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },

    // 柱形图
    createdCarEchartsRightBottom() {
      var leftEchartsTOP = document.getElementById("right-echarts-1");
      var myChart = echarts.init(leftEchartsTOP);
      var option;

      option = {
        title: {
          subtext: "单位：Kg",
          left: "right",
          subtextStyle: {
            color: "#FFF",
            fontSize: "20",
          },
        },
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            return (
              params.name +
              ":  " +
              params.data.value +
              "（" +
              params.percent +
              "%）"
            );
          },
        },
        color: [
          "#5470c6",
          "#91cc75",
          "#fac858",
          "#ee6666",
          "#73c0de",
          "#3ba272",
          "#fc8452",
          "#9a60b4",
          "#ea7ccc",
        ],
        legend: {
          bottom: "bottom",
          textStyle: {
            fontSize: 20,
            color: "#FFFFFF",
          },
        },

        series: [
          {
            name: "数量",
            type: "pie",
            radius: "40%",
            data: [
              { value: 23, name: "三元催化剂" },
              { value: 53, name: "电脑板" },
              { value: 24, name: "废铅酸蓄电池" },
              { value: 20, name: "其他" },
            ],
            label: {
              fontSize: 12,
              color: "#FFF",
              formatter(param) {
                return param.percent + "%";
              },
            },
          },
        ],
      };

      option && myChart.setOption(option);
    },
  },
};
</script>
  <style scoped lang="scss">
.mainitem {
  ::-webkit-scrollbar {
    width: 0px;
  }
  .left,
  .right {
    width: 23vw;
    height: 75vh;
    background: rgba(17,47,107, 0.6);
    overflow: hidden;
  }
  .left {
    float: left;
    margin-left: 20px;
    .left-content {
      box-sizing: border-box;
      padding: 20px;
      color: #fff;
      height: 55%;
      .company-content {
        line-height: 40px;
        font-size: 20px;
        height: 90%;
        // background: #fff;

        overflow-y: scroll;
        scroll-behavior: smooth;
        overscroll-behavior: contain;
        .item-list {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 0;
          border-bottom: 1px solid rgb(200, 200, 200);
        }
      }
    }
  }
  .right {
    float: right;
    margin-right: 20px;
    .right-content {
      box-sizing: border-box;
      padding: 20px;
      color: #fff;
      height: 50%;
      .company-content {
        line-height: 40px;
        font-size: 20px;
        height: 90%;
        overflow-y: scroll;
        scroll-behavior: smooth;
        overscroll-behavior: contain;
        .item-list {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 0;
          border-bottom: 1px solid rgb(200, 200, 200);
        }
      }
    }
  }

  .left .left-content .type-title,
  .right .right-content .type-title {
    font-size: 22px;
    margin-bottom: 10px;
    border-left: 6px rgb(115, 95, 250) solid;
    padding-left: 15px;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  /* echarts */
  /* 汽废左侧饼图 */
  .left-echarts-1,
  .right-echarts-1 {
    width: 100%;
    height: 100%;
  }
}
</style>
  